"use strict";import{CloseButton as e}from"./src/CloseButton.js";import{defineElement as o}from"@spectrum-web-components/base/src/define-element.js";o("sp-close-button",e);
//# sourceMappingURL=sp-close-button.js.map
